import initialBookingStateSelector from '../selectors/InitialBookingStateSelector';

export const getDoctorCardPropsFromInitialBookingState = (storeState) => {
    const initialBookingState = initialBookingStateSelector(storeState);

    return {
        appointmentTime: initialBookingState.appointmentTime,
        locationId: initialBookingState.locationId,
        locationTimeZoneId: initialBookingState.locationTimeZoneId,
        procedureId: initialBookingState.procedureId,
        providerId: initialBookingState.professionalId,
    };
};
